export default {
  UPLOAD_PREVIEW_AVATAR_IMAGE: 'UPLOAD_PREVIEW_AVATAR_IMAGE',
  UPLOAD_PREVIEW_AVATAR_IMAGE_SUCCESS: 'UPLOAD_PREVIEW_AVATAR_IMAGE_SUCCESS',
  UPLOAD_PREVIEW_AVATAR_IMAGE_FAILURE: 'UPLOAD_PREVIEW_AVATAR_IMAGE_FAILURE',

  SAVE_AND_CROP_AVATAR_IMAGE: 'SAVE_AND_CROP_AVATAR_IMAGE',
  SAVE_AND_CROP_AVATAR_IMAGE_SUCCESS: 'SAVE_AND_CROP_AVATAR_IMAGE_SUCCESS',
  SAVE_AND_CROP_AVATAR_IMAGE_FAILURE: 'SAVE_AND_CROP_AVATAR_IMAGE_FAILURE',

  UPLOAD_PREVIEW_BANNER_IMAGE: 'UPLOAD_PREVIEW_BANNER_IMAGE',
  UPLOAD_PREVIEW_BANNER_IMAGE_SUCCESS: 'UPLOAD_PREVIEW_BANNER_IMAGE_SUCCESS',
  UPLOAD_PREVIEW_BANNER_IMAGE_FAILURE: 'UPLOAD_PREVIEW_BANNER_IMAGE_FAILURE',

  SAVE_AND_CROP_BANNER_IMAGE: 'SAVE_AND_CROP_BANNER_IMAGE',
  SAVE_AND_CROP_BANNER_IMAGE_SUCCESS: 'SAVE_AND_CROP_BANNER_IMAGE_SUCCESS',
  SAVE_AND_CROP_BANNER_IMAGE_FAILURE: 'SAVE_AND_CROP_BANNER_IMAGE_FAILURE',
};
